import { render, staticRenderFns } from "./editWonderful.vue?vue&type=template&id=3eaf4774&scoped=true&"
import script from "./editWonderful.vue?vue&type=script&lang=js&"
export * from "./editWonderful.vue?vue&type=script&lang=js&"
import style0 from "./editWonderful.vue?vue&type=style&index=0&id=3eaf4774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf4774",
  null
  
)

export default component.exports